export namespace Color {
  export const Brand1 = '#CCDDED';
  export const Brand2 = '#E6EEF6';
  export const Brand3 = '#B3CCE3';
  export const Brand4 = '#81AAD1';
  export const Brand5 = '#3877B0';
  export const Brand6 = '#0255A3';
  export const Brand7 = '#013B72';
  export const Brand8 = '#012B52';
  export const Brand9 = '#011E39';
  export const Brand10 = '#000D18';
  export const Gray1 = '#FFFFFF';
  export const Gray2 = '#F9FBFC';
  export const Gray3 = '#F2F5F7';
  export const Gray4 = '#DADDE0';
  export const Gray5 = '#BDC2C7';
  export const Gray6 = '#989EA6';
  export const Gray7 = '#5C6572';
  export const Gray8 = '#353D4A';
  export const Gray9 = '#1B2028';
  export const Gray10 = '#101217';
  export const Green1 = '#F6FFED';
  export const Green2 = '#D9F7BE';
  export const Green3 = '#B7EB8F';
  export const Green4 = '#95DE64';
  export const Green5 = '#73D13D';
  export const Green6 = '#52C41A';
  export const Green7 = '#389E0D';
  export const Green8 = '#237804';
  export const Green9 = '#135200';
  export const Green10 = '#092B00';
  export const Red1 = '#FFF1F0';
  export const Red2 = '#FFCCC7';
  export const Red3 = '#FFA39E';
  export const Red4 = '#FF7875';
  export const Red5 = '#FF4D4F';
  export const Red6 = '#F5222D';
  export const Red7 = '#CF1322';
  export const Red8 = '#A8071A';
  export const Red9 = '#820014';
  export const Red10 = '#5C0011';
  export const Orange1 = '#FFF7E6';
  export const Orange2 = '#FFE7BA';
  export const Orange3 = '#FFD591';
  export const Orange4 = '#FFC069';
  export const Orange5 = '#FFA940';
  export const Orange6 = '#FA8C16';
  export const Orange7 = '#D46B08';
  export const Orange8 = '#AD4E00';
  export const Orange9 = '#873800';
  export const Orange10 = '#612500';
  export const White1 = '#FAFCFD';
}
